import { connectRouter, RouterState } from 'connected-react-router';
import { History } from 'history';
import { combineReducers } from 'redux';
import authReducer, { authState, IAuthState } from './auth/authSlice';

import commonReducer, { commonState, ICommonState } from './common/commonSlice';
import dialogReducer, { dialogState, IDialogState } from './dialog/dialogSlice';
import fileReducer, { fileState, IFileState } from './file/fileSlice';
import formReducer, { formState, IFormState } from './form/formSlice';
import lightboxReducer, { ILightboxState, lightboxState } from './lightbox/lightboxSlice';
import printReducer, { IPrintState, printState } from './print/printSlice';
import reportReducer, { IReportState, reportState } from './report/reportSlice';

export interface IRootState<TFormData = any> {
  router: RouterState;
  common: ICommonState;
  auth: IAuthState;
  dialog: IDialogState;
  file: IFileState;
  form: IFormState<TFormData>;
  lightbox: ILightboxState;
  report: IReportState;
  print: IPrintState;
}

export const rootState: IRootState = {
  router: undefined,
  auth: authState,
  common: commonState,
  dialog: dialogState,
  file: fileState,
  form: formState,
  lightbox: lightboxState,
  report: reportState,
  print: printState,
};

/* ------------- Assemble The Reducers ------------- */
const createRootReducer = (history: History) => {
  return combineReducers<IRootState>({
    router: connectRouter(history),
    common: commonReducer,
    auth: authReducer,
    dialog: dialogReducer,
    file: fileReducer,
    form: formReducer,
    lightbox: lightboxReducer,
    report: reportReducer,
    print: printReducer,
  });
};

export default createRootReducer;
